import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatError } from "../context/AuthContext";
import { Logo } from "../components/common";

const AUTH_BG = "https://images.unsplash.com/photo-1648235692910-947cb90ddd97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxkYXJrJTIwcHJlbWl1bSUyMGZpdG5lc3MlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4MjUyNjQ1OHww&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back!");
      navigate(user.role === "customer" ? (user.onboarded ? "/app" : "/onboarding") : "/coach");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:block w-1/2 relative">
        <img src={AUTH_BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] to-transparent" />
        <div className="absolute bottom-12 left-12">
          <h2 className="font-heading text-6xl leading-none">Your next<br /><span className="text-brand">rep starts here.</span></h2>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <Link to="/"><Logo /></Link>
          <h1 className="font-heading text-4xl mt-10">Welcome back</h1>
          <p className="text-secondary mt-1">Log in to continue your training.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="label-xs block mb-2">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-surface-elevated border border-border rounded-lg px-4 py-3 focus:outline-none focus:border-brand transition-colors" />
            </div>
            <div>
              <label className="label-xs block mb-2">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-surface-elevated border border-border rounded-lg px-4 py-3 focus:outline-none focus:border-brand transition-colors" />
            </div>
            <button data-testid="login-submit" disabled={loading}
              className="w-full py-3 bg-brand text-white font-bold uppercase tracking-wide rounded-lg hover:bg-brand-hover transition-all disabled:opacity-60">
              {loading ? "Logging in..." : "Log In"}
            </button>
          </form>
          <div className="flex items-center gap-3 my-5">
            <div className="flex-1 h-px bg-border" /><span className="text-tertiary text-xs">OR</span><div className="flex-1 h-px bg-border" />
          </div>
          <button data-testid="login-google" onClick={google}
            className="w-full py-3 border border-white/20 rounded-lg font-semibold hover:border-white transition-all flex items-center justify-center gap-2">
            <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4" /> Continue with Google
          </button>
          <p className="text-secondary text-sm mt-6 text-center">
            No account? <Link to="/signup" className="text-brand font-semibold">Sign up</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
